<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epig"> </p>
<p class="Epi1">    What mad pursuit? What struggle to escape?</p>
<p class="Epi1">        What pipes and timbrels? What wild ecstasy?</p>
<p class="Epi">                 —John Keats, “Ode on a Grecian Urn”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?28ccbde8